import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
    const { pathname } = useLocation();
    if (pathname.startsWith("/check") || pathname.startsWith("/login") || pathname.startsWith("/register") || pathname.startsWith("/admin") || pathname.startsWith("/auth/callback")) {
        return null;
    }
    return (
        <div className="sticky-cta fixed inset-x-0 bottom-0 z-30 border-t border-ink-300/30 bg-white/95 backdrop-blur-xl lg:hidden">
            <div className="container flex items-center gap-3 py-3">
                <div className="flex-1 leading-tight">
                    <div className="text-[11px] text-ink-500">In 3 Minuten klar</div>
                    <div className="font-display text-sm font-semibold">Kostenlose Ersteinschätzung</div>
                </div>
                <Link
                    to="/check"
                    data-testid="sticky-cta-check"
                    className="inline-flex items-center gap-2 rounded-full bg-brand-500 px-5 py-3 text-sm font-semibold text-white shadow-soft transition hover:bg-brand-600"
                >
                    Prüfung starten
                    <ArrowRight className="h-4 w-4" />
                </Link>
            </div>
        </div>
    );
}
